import { Link } from "react-router-dom";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Logo } from "@/components/Logo";

export function AuthShell({ eyebrow, title, subtitle, children, testid }) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="h-16 border-b border-border bg-card flex items-center justify-between px-6">
        <Link to="/" data-testid="auth-home-link"><Logo className="h-9" /></Link>
        <ThemeToggle />
      </header>
      <div className="flex-1 grid place-items-center px-6 py-12">
        <div className="w-full max-w-md" data-testid={testid}>
          <div className="text-xs font-bold uppercase tracking-widest text-primary mb-2">{eyebrow}</div>
          <h1 className="font-heading font-black text-4xl tracking-tight">{title}</h1>
          {subtitle && <p className="text-muted-foreground text-sm mt-2">{subtitle}</p>}
          <div className="mt-8 border border-border bg-card p-6 sm:p-8">{children}</div>
        </div>
      </div>
    </div>
  );
}

export function MockOtpNote({ code }) {
  if (!code) return null;
  return (
    <div className="border border-dashed border-amber-500/60 bg-amber-500/10 p-3 text-xs" data-testid="mock-otp-note">
      <span className="font-bold uppercase tracking-wide text-amber-600 dark:text-amber-400">Test mode SMS:</span>{" "}
      your OTP is <span className="font-mono-num font-bold text-base text-foreground" data-testid="mock-otp-code">{code}</span>
    </div>
  );
}

export default AuthShell;
